/* eslint-disable no-unused-vars */
import { useEffect, useState, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CssBaseline from "@mui/material/CssBaseline";
import routes from "routes";
import ProtectedRoute from "components/ProtectedRoute";
import PersistLogin from "components/PersistLogin";
import BoxLoading from "components/BoxLoading/boxLoading";
import NotFoundPage from "components/Page404/NotFoundPage";
import Configurator from "components/Configurator";
import GetUser from "components/getUser";
import Sidenav from "components/Sidenav";
import { setMiniSidenav, useMaterialUIController } from "context";
import brandDark from "assets/images/logo-ct.png";
import brandWhite from "assets/images/logo-ct.png";
import { ThemeProvider } from "@mui/material/styles";
import themeLight from "assets/theme";
import themeDark from "assets/theme-dark";
import { Font } from "@react-pdf/renderer";
import RobotoRegular from "assets/Fonts/Roboto/Roboto-Regular.ttf";
import { API_ROUTES } from "utils/constants";
import { useRecoilState, useSetRecoilState } from "recoil";
import { StatusDuAnState, AlertState } from "states";
import CustomAlert from "components/CustomAlert";
import axios from "axios";
// Register the font outside the component
Font.register({
  family: "RobotoRegular",
  src: RobotoRegular,
});

const App = () => {
  const { t } = useTranslation();
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    sidenavColor,
    homePage,
    whiteSidenav,
    transparentSidenav,
    darkMode,
    layout,
    anotherPage,
  } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const setStatusProject = useSetRecoilState(StatusDuAnState);
  const [alert, setAlert] = useRecoilState(AlertState);

  const getRoutes = (allRoutes, parentPath = "") => {
    return allRoutes.flatMap((route, index) => {
      if (route.route) {
        const fullPath = parentPath + route.route;
        return (
          <Route
            exact
            path={fullPath}
            element={
              <ProtectedRoute access={route.access} permission={route.key}>
                {route.component}
              </ProtectedRoute>
            }
            key={"route_" + route.key + "_" + index}
          />
        );
      }
      if (route.collapse) {
        // Tạo route cho parent nếu có
        const parentRoute = route.route ? (
          <Route
            exact
            path={parentPath + route.route}
            element={
              <ProtectedRoute access={route.access} permission={route.key}>
                {route.component}
              </ProtectedRoute>
            }
            key={"parent_" + route.key + "_" + index}
          />
        ) : null;

        // Đệ quy để xử lý các route con trong collapse
        const childRoutes = getRoutes(
          route.collapse,
          parentPath + (route.route || "")
        );
        return [parentRoute, ...childRoutes];
      }
      return null;
    });
  };

  const splitRoutes = (routes) => {
    const publicRoutes = [];
    const protectedRoutes = [];

    routes.forEach((route) => {
      if (route.access === 0 || route.access === 3) {
        publicRoutes.push(route);
      } else {
        protectedRoutes.push(route);
      }
      if (route.collapse) {
        const { publicRoutes: childPublic, protectedRoutes: childProtected } =
          splitRoutes(route.collapse);
        publicRoutes.push(...childPublic);
        protectedRoutes.push(...childProtected);
      }
    });

    return { publicRoutes, protectedRoutes };
  };

  const { publicRoutes, protectedRoutes } = splitRoutes(routes);

  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  useEffect(() => {
    const getAllStattusProject = async () => {
      try {
        const response = await axios.get(API_ROUTES.TRANGTHAI);
        let result = {};
        response.data?.forEach((item) => {
          result[item?.id] = item;
        });
        setStatusProject(result);
      } catch (error) {
        if (error.response && error.response.status === 500) {
          setAlert({
            alert: true,
            message: "Đã xảy ra lỗi 500. Vui lòng thử lại sau.",
            type: "error",
          });
        } else {
          console.error(error.response);
        }
        return;
      }
    };
    getAllStattusProject();
  }, []);

  const handleCloseAlert = () => {
    setAlert({ alert: false, message: null, type: null });
  };

  return (
    <ThemeProvider theme={darkMode ? themeDark : themeLight}>
      <CssBaseline />
      <CustomAlert alert={alert} onClose={handleCloseAlert} />
      {!homePage && !anotherPage && layout !== "page" && (
        <>
          <GetUser />
          <Sidenav
            color={sidenavColor}
            brand={
              (transparentSidenav && !darkMode) || whiteSidenav
                ? brandDark
                : brandWhite
            }
            brandName={t("brandName")}
            routes={routes}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          />
          <Configurator />
        </>
      )}
      <Suspense fallback={<BoxLoading />}>
        <Routes>
          {getRoutes(publicRoutes)}
          <Route element={<PersistLogin />}>{getRoutes(protectedRoutes)}</Route>
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </ThemeProvider>
  );
};

export default App;
